import './travel-agency-finder.scss';

import AjaxLoad from '../../utilities/js/ajax-load';
import { dispatchForCode, createElementFromHTML } from '../../utilities/js/helper';
import { Pagination } from '../../components/pagination/pagination';

class TravelAgencyFinder {
    constructor ($element) {
        this.$travelAgencyFinder = $element;
        this.$form = this.$travelAgencyFinder.querySelector('[data-travel-agency-finder="form"]');
        this.$zipCode = this.$travelAgencyFinder.querySelector('[data-travel-agency-finder="zipcode"]');
        this.lastZipCodeValue = this.$zipCode.value;
        this.$results = this.$travelAgencyFinder.querySelector('[data-travel-agency-finder="results"]');
        this.$countrys = this.$travelAgencyFinder.querySelectorAll('input[name="country"]');
        this.$topPartners = this.$travelAgencyFinder.querySelector('input[name="topPartners"]');
        this.formTarget = this.$form.getAttribute('action');

        this.pagination = new Pagination(this.$results, {
            paginationAttr: '[data-travel-agency-finder="pagination"]',
            selectPaginationAttr: '[data-travel-agency-finder="select-pagination"]'
        });

        this.allowedKeys = [
            '1', '2', '3', '4', '5', '6', '7', '8', '9', '0', 'Backspace', 'Tab', 'Delete', 'ArrowLeft', 'ArrowRight'
        ];

        this.waitTimer = null;
        this.hasChanges = false;
        this.ajaxActive = false;
    }

    initialize () {
        this.setEvents();
        this.pagination.check((action) => {
            this.formTarget = action;
            this.checkBeforeSubmit();
        });
    }

    setEvents () {
        // For Desktop Devices KeyUp and keyDown Check
        this.$zipCode.addEventListener('keydown', (event) => {
            if (window.browser.csshover) { // eslint-disable-line
                dispatchForCode(event, (code) => {
                    if (this.allowedKeys.includes(code)) {
                        const country = this.$travelAgencyFinder.querySelector('[name="country"]:checked').value;

                        if (code >= 0 && code <= 9) {
                            if (((country === 'AT' || country === 'CH') && this.$zipCode.value.length >= 4) || (country === 'DE' && this.$zipCode.value.length >= 5)) {
                                event.preventDefault();
                            } else {
                                if (this.$zipCode.value.length >= 2 && this.lastZipCodeValue !== this.$zipCode.value) {
                                    this.hasChanges = true;
                                }
                            }
                        } else {
                            this.hasChanges = true;
                        }
                    } else {
                        event.preventDefault();
                    }
                });
            }
        });

        this.$zipCode.addEventListener('keyup', (event) => {
            if (window.browser.csshover) { // eslint-disable-line
                if (this.hasChanges) {
                    this.formTarget = this.$form.getAttribute('action');
                    this.checkBeforeSubmit(300);
                }
            }
        });

        // For Mobile Devices Input check
        this.$zipCode.addEventListener('input', (event) => {
            if (!window.browser.csshover) { // eslint-disable-line
                let keysAllowed = false;

                if (this.$zipCode.value.length > this.lastZipCodeValue.length) {
                    const lastKey = this.$zipCode.value.substr(this.lastZipCodeValue.length);

                    if (lastKey.length > 1) {
                        let i = lastKey.length;

                        while (i--) {
                            keysAllowed = this.allowedKeys.includes(lastKey[i]);
                        }
                    } else {
                        keysAllowed = this.allowedKeys.includes(lastKey);
                    }

                    if (keysAllowed) {
                        const country = this.$travelAgencyFinder.querySelector('[name="country"]:checked').value;

                        if (((country === 'AT' || country === 'CH') && this.$zipCode.value.length >= 5) || (country === 'DE' && this.$zipCode.value.length >= 6)) {
                            this.$zipCode.value = this.lastZipCodeValue;
                            this.hasChanges = false;
                        } else {
                            if (this.$zipCode.value.length >= 2 && this.lastZipCodeValue !== this.$zipCode.value) {
                                this.hasChanges = true;
                            }
                        }
                    } else {
                        this.$zipCode.value = this.lastZipCodeValue;
                        this.hasChanges = false;
                    }
                } else {
                    if (this.$zipCode.value !== this.lastZipCodeValue) {
                        this.hasChanges = true;
                    }
                }

                if (this.hasChanges) {
                    this.formTarget = this.$form.getAttribute('action');
                    this.checkBeforeSubmit(300);
                }

                this.lastZipCodeValue = this.$zipCode.value;
            }
        });

        this.$topPartners.addEventListener('change', () => {
            this.formTarget = this.$form.getAttribute('action');
            this.checkBeforeSubmit(0);
        });

        this.$countrys.forEach((country) => {
            country.addEventListener('change', () => {
                if (country.value === 'AT' || country.value === 'CH') {
                    if (this.$zipCode.value.length > 4) {
                        this.$zipCode.value = this.$zipCode.value.substr(0, 4);
                    }
                }
                this.formTarget = this.$form.getAttribute('action');
                this.checkBeforeSubmit(0);
            });
        });

        this.$form.addEventListener('submit', (e) => {
            e.preventDefault();
            this.formTarget = this.$form.getAttribute('action');
            this.checkBeforeSubmit(0);
        });
    }

    checkBeforeSubmit (timer) {
        clearTimeout(this.waitTimer);

        if (this.ajaxActive === false) {
            this.waitTimer = setTimeout(() => {
                this.$results.appendChild(createElementFromHTML(window.OPTIONS.loader));
                this.sendRequest();
                this.ajaxActive = true;
            }, timer);
        } else {
            console.log('Please wait.....Ajax is running');
        }
    }

    sendRequest () {
        this.result = new AjaxLoad(this.formTarget, {
            requestMethod: 'post',
            requestData: new FormData(this.$form),
            onSuccess: (resultText) => {
                const results = JSON.parse(resultText);
                this.setResult(results);
                this.lastZipCodeValue = this.$zipCode.value;
            },
            onError: (error) => {
                console.warn(error);
            }
        });
    }

    setResult (results) {
        this.ajaxActive = false;
        const $result = createElementFromHTML(results.html);
        this.$results.innerHTML = '';

        if ($result.length > 1) {
            $result.forEach((item) => {
                this.$results.appendChild(item);
            });
        } else {
            this.$results.appendChild($result);
        }

        this.pagination.check((action) => {
            this.formTarget = action;
            this.checkBeforeSubmit();
        });
    }
}

export { TravelAgencyFinder };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    const $travelAgencyFinder = $context.querySelector('[data-travel-agency-finder="root"]');

    if ($travelAgencyFinder) {
        const finder = new TravelAgencyFinder($travelAgencyFinder);
        finder.initialize();
    }
});
